import { render, staticRenderFns } from "./PopMenu.vue?vue&type=template&id=e0c84132&scoped=true&"
import script from "./PopMenu.vue?vue&type=script&lang=js&"
export * from "./PopMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c84132",
  null
  
)

export default component.exports